import { AppState, User } from '@auth0/auth0-react';
import history from 'utils/history';

export enum Role {
  SaviConnectUser = 'Hospital User',
  SaviConnectManager = 'Hospital Manager',
  Admin = 'Manager / Admin', // aka supplier
  MkSystemAdmin = 'mk_system_admin',
  MkSystemOperator = 'mk_system_operator',
  SaviConnectViewer = 'Hospital Viewer',
}

export const userRolesIndex = 'https://savi.maxkelsen.com/roles';

export interface SaviWebAuth0User extends User {
  'https://savi.maxkelsen.com/roles': Role[];
  org_id: string;
}

/**
 * @example {"error":"access_denied","error_description":"user auth0|123abc is not part of the org_123abc organization"}
 * @example {"error":"access_denied","error_description":"Please change your password"}
 */

export class Auth0Error extends Error {
  error: string;
  error_description: string;

  constructor(error: string | Error | Auth0Error, error_description?: string) {
    const err = error as any; // The Auth0 lib makes and Error with extras
    const errorStr = 'string' == typeof error ? error : err.error || err.message;
    const errorDesc = error_description || err.error_description || errorStr;
    super(errorDesc);
    this.error = errorStr;
    this.error_description = errorDesc;
  }
}

export const onRedirectCallback = (appState: AppState | undefined): void => {
  sessionStorage.setItem('postLoginRedirect', 'true');

  history.push(appState?.returnTo ? appState.returnTo : window.location.pathname);
};
